import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import styled from 'styled-components';
import Markdown from 'markdown-to-jsx';
import { textBold } from 'styles';
import { breakpoint } from 'utils/mediaQueries';

const NameMarkdown = styled(Markdown)`
  ${textBold};
  font-family: ${props => `${props.theme.typography.fontFamily}
`};
  font-size: ${props => `${props.theme.typography.subtitle2.fontSize}px`};
`;
const GridName = styled(Grid)`
  padding: 0.5rem;
  flex: 0 0 auto;
  text-align: ${props => props.textalign};
  ${breakpoint.down('md')`
  align-items: flex-start; text-align:left;`};
`;
const StyledGrid = styled(Grid)`
  flex: 1;
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    flex: 0 0 auto;
  }
`;
const BlockName = ({ data, order }) => {
  return (
    <GridName
      container
      direction={'column'}
      item
      xs={10}
      sm={10}
      md={6}
      lg={6}
      alignItems={order === 'even' ? 'flex-start' : 'flex-end'}
      textalign={order === 'even' ? 'left' : 'right'}
    >
      <StyledGrid
        container
        direction={'column'}
        item
        xs={12}
        sm={12}
        md={order === 'even' ? 11 : 4}
        lg={order === 'even' ? 8 : 4}
      >
        <NameMarkdown variant={'subtitle2'}>
          {data.frontmatter.name}
        </NameMarkdown>
      </StyledGrid>
      <Typography variant={'body2'}>{data.frontmatter.role}</Typography>
    </GridName>
  );
};
export default BlockName;
